// 业务类型
export const BIZ_TYPES = {
  // 整数
  Integer: 'integer',
  // 整数+2位小数
  Float: 'float',

  // 手机号
  Phone: 'phone',
  // 金额
  Money: 'money',
  // 百分比
  Percent: 'percent',
  // 公里
  Km: 'km',
  // 身份证号
  IdCard: 'idCard',
}
